import { useEffect, useState } from "react";
import { CloseGreyIcon } from "../../../assets/icons";
import { GetPlanFeatureResponseDTO } from "../../../models/planFeature/planFeture.response";
import { useNotification } from "../../toster-notification/NotificationContext";
import { planFeatureService } from "../../../services/planFeatureService";

interface DeletePlanFeatureViewProps {
    onClose: () => void;
}

const DeletePlanFeatureView: React.FC<DeletePlanFeatureViewProps> = ({ onClose }) => {
    const [functionalities, setFunctionalities] = useState<GetPlanFeatureResponseDTO[]>([]);

    const [selectedFunctionalities, setSelectedFunctionalities] = useState<string[]>([]);

    const [loading, setLoading] = useState<boolean>(false);

    const { notify } = useNotification();


    useEffect(() => {
        fetchFunctionalities();
    }, []);


    const fetchFunctionalities = async () => {
        setLoading(true);

        try {
            const response = await planFeatureService.getPlanFeatures();
            if (response.success && response.data) {
                setFunctionalities(response.data);
            }
        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                notify("error", error.response.data.message);
            } else {
                notify("error", "Došlo je do greške prilikom učitavanja funkcionalnosti.");
            }

        } finally {
            setLoading(false);
        }
    };

    const handleDeleteFunctionalities = async () => {
        if (selectedFunctionalities.length === 0) {
            notify("error", "Nije izabrana nijedna funkcionalnost za brisanje.");
            return;
        }

        setLoading(true);
        try {
            const response = await planFeatureService.deletePlanFeatures(selectedFunctionalities);
            if (response.success) {
                notify("success", response.message || "Funkcionalnosti su uspešno obrisane.");
                onClose();
            }
        } catch (error: any) {
            notify("error", error.message || "Došlo je do greške prilikom brisanja funkcionalnosti.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="modal-section plan-func-delete">
            <div className="w-layout-blockcontainer container w-container">
                <div className="modal-wrapper">
                    <div className="modal-div">
                        <div className="modal-header-div">
                            <div>
                                <div className="modal-header">
                                    <strong>Obriši postojeću funkcionalnost</strong>
                                </div>
                                <div className="description-text">Obriši postojeću funkcionalnost plana</div>
                            </div>
                            <div className="modal-button-div" onClick={onClose}>
                                <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" />
                            </div>
                        </div>
                        <div className="modal-body-div">
                            <div className="modal-form-label">Izaberi funkcionalnosti za brisanje</div>
                            <div className="modal-body-list-div">

                                {functionalities.map((func) => (
                                    <div className={`small-box-div pointer ${selectedFunctionalities.includes(func.id) ? "dark-red-bg" : ""}`} key ={func.id}
                                        onClick={() => setSelectedFunctionalities( selectedFunctionalities.includes(func.id) ? selectedFunctionalities.filter(id => id !== func.id) : [...selectedFunctionalities, func.id])}
                                    >
                                        <div>{func.name}</div>
                                        <div className="fs-0-75">{"{"}{func.key || "N/A"}{"}"}</div>
                                    </div>
                                ))}

                            </div>
                        </div>
                        <div className="modal-buttons">
                            <div className="button-secondary medium" onClick={onClose}>
                                <div>Otkaži</div>
                            </div>
                            <div className="button-primary medium red-bg" onClick={() => handleDeleteFunctionalities()}>
                                <div>Obriši funkcionalnosti</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
};

export default DeletePlanFeatureView;